<template>
    <div>
        <div v-if="getFlagSharedAgencyLoggedIn === true">
            <!-- Begin:PageContent -->
            <section id="content">
                <div class="container">
                    <div class="row">
                        <!-- >>> Left Side: Content -->
                        <div id="main" class="col-md-9">
                            <div class="container shortcode travel-ideas">
                                <h1 class="idea-title"><span class="index"><i class="soap-icon-star circle" style="background: #3bdd4e;"></i></span>{{ titleinfo[getCurrentLocale] }}</h1>
                            </div>
                            <br />

                            <!-- >>> Still no Booking Results -->
                            <div class="sdr-box booking-information" v-if="get_shared_AgencyGetBookings.length === 0">
                                <h3 class="skin-color">{{ stillempty[getCurrentLocale] }}</h3>
                            </div>
                            <!-- <<< Still no Booking Results -->


                            <!-- >>> Some Booking Results ------------------ -->
                            <!-- >>> Filter Area -->
                            <div class="search-tab-content sdr-box booking-information" v-if="get_shared_AgencyGetBookings.length > 0">
                                <div class="tab-pane fade  active in" id="online-checkin-tab">
                                    <form @submit.prevent="onSubmit_FilterSearch">
                                        <div class="row">
                                            <div class="col-xs-6 col-md-3">
                                                <h4 class="title">{{ when[getCurrentLocale] }}</h4>
                                                <div class="form-group">
                                                    <label>{{ flightdatefilter[getCurrentLocale] }}</label>
                                                    <vue-pikaday
                                                        v-model="searchfor_flightdate"
                                                        name="searchfor_flightdate"
                                                        placeholder=""
                                                        class="input-text full-width"
                                                        :options="options[getCurrentLocale]"
                                                        :value="start"
                                                    />
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <h4 class="title">{{ what[getCurrentLocale] }}</h4>
                                                <div class="form-group row">
                                                    <div class="col-xs-4">
                                                        <label>{{ bookingcodefilter[getCurrentLocale] }}</label>
                                                        <input type="text" class="input-text full-width" placeholder="e.g. Q3KEEU89" v-model="searchfor_bookingcode" />
                                                    </div>
                                                    <div class="col-xs-4">
                                                        <label>{{ invoiceidfilter[getCurrentLocale] }}</label>
                                                        <input type="text" class="input-text full-width" placeholder="e.g. 747978" v-model="searchfor_invoiceid" />
                                                    </div>
                                                    <div class="col-xs-4">
                                                        <label>{{ surnamefilter[getCurrentLocale] }}</label>
                                                        <input type="text" class="input-text full-width" placeholder="e.g. Ibrahimi" v-model="searchfor_surname" />
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-group col-md-3 fixheight">
                                                <label class="hidden-xs">&nbsp;</label>
                                                <button class="icon-check full-width">{{ filterbookings[getCurrentLocale] }}</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <!-- <<< Filter Area -->


                            <!-- >>> Upper Buttons -->
                            <button type="button" class="btn-large full-width totalbutton" style="cursor: initial; outline: none !important; outline-style: none !important; margin-bottom: 15px; background: #3bdd4e; font-size: 1.4em; height: 65px;" v-if="get_shared_AgencyGetBookings.length > 0">
                                {{ totalagencyprice[getCurrentLocale] }}: {{ Number(get_shared_AgencyAgencyTotalBrutto) | rndAmntRUAFWZ }},  {{ totalcustomerprice[getCurrentLocale] }}: {{ Number(get_shared_AgencyTotalBrutto) | rndAmntRUAFWZ }}
                                <br />
                                <span style="font-size: 0.5em;">{{ tincludedtaxes[getCurrentLocale] }}</span>
                            </button>
                            <div style="text-align: end; font-size: 1.0rem; font-weight: 700; margin-bottom: 20px; color: rgb(0, 160, 19);" v-if="get_shared_AgencyGetBookings.length > 0">
                                {{ freecashlimit[getCurrentLocale] }}: {{ Number(get_shared_AgencyAgencyCashLimit) | rndAmntRUAFWZ }}
                            </div>
                            <button type="button" class="btn-large full-width totalbutton" style="cursor: initial; outline: none !important; outline-style: none !important; margin-bottom: 30px; background: #00a013; font-size: 1.4em; height: 35px;" v-if="get_shared_AgencyGetBookings.length > 0">
                                <a href="#" v-on:click.prevent="onClick_ExcelDownload(booking)">
                                    <div class="xskin-color" style="font-size: 1.0625em; width: 100%;" >{{ downloadexcel[getCurrentLocale] }} &#10507;</div>
                                </a>
                            </button>
                            <!-- <<< Upper Buttons -->


                            <!-- >>> Core -->
                            <div class="sdr-box booking-information" v-if="get_shared_AgencyGetBookings.length > 0">
                                <div id="booking" class="tab-pane">
                                    <div class="booking-history">
                                        <div class="booking-info clearfix" v-for="(booking, index) in get_shared_AgencyGetBookings_Filtered" v-bind:key="index">
                                            <div class="date">
                                                <label class="month">{{ booking.addendum.bookingDate | monthname }}</label>
                                                <label class="date">{{ booking.addendum.bookingDate | dayofmonth }}</label>
                                                <label class="day">{{ booking.addendum.bookingDate | weekday }}</label>
                                            </div>
                                            <h5 class="box-title">
                                                <i class="icon soap-icon-plane-right takeoff-effect circle" style="color: #3bdd4e;" v-if="get_BookedOrPartialOrFull(booking) === 'fullybooked'"></i>
                                                <i class="icon soap-icon-plane-right takeoff-effect circle" style="color: #ffd60a;" v-if="get_BookedOrPartialOrFull(booking) === 'partialcancelled'"></i>
                                                <i class="icon soap-icon-plane-right takeoff-effect circle" style="color: #E74C3C;" v-if="get_BookedOrPartialOrFull(booking) === 'fullycancelled'"></i>

                                                <span v-if="get_BookedOrPartialOrFull(booking) === 'fullybooked'" style="font-weight: 600;">{{ agenturprice[getCurrentLocale] }}: {{ Number(booking.addendum.agencyPrice) | rndAmntRUAFWZ }}; {{ agenturcommission[getCurrentLocale] }}: {{ Number(booking.addendum.agencyCommission) | rndAmntRUAFWZ }}; {{ customerprice[getCurrentLocale] }}: {{ Number(booking.addendum.bruttoTotal) | rndAmntRUAFWZ }}</span>
                                                <span v-if="get_BookedOrPartialOrFull(booking) !== 'fullybooked'">-</span>

                                                <span>
                                                    <small style="padding-left: 37px; width: 400px;">
                                                        <span style="color: #3bdd4e; text-transform: uppercase; font-weight: 600;" v-if="get_BookedOrPartialOrFull(booking) === 'fullybooked'">{{ fullybooked[getCurrentLocale] }}{{ booking.addendum.rebookingInvoice === true ? ' ' + rebookingumbuchung[getCurrentLocale] : '' }};&nbsp;</span>
                                                        <span style="color: #ffd60a; text-transform: uppercase; font-weight: 600;" v-if="get_BookedOrPartialOrFull(booking) === 'partialcancelled'">{{ partialcancelled[getCurrentLocale] }}{{ booking.addendum.rebookingInvoice === true ? ' ' + rebookingumbuchung[getCurrentLocale] : '' }};&nbsp;</span>
                                                        <span style="color: #E74C3C; text-transform: uppercase; font-weight: 600;" v-if="get_BookedOrPartialOrFull(booking) === 'fullycancelled'">{{ fullycancelled[getCurrentLocale] }}{{ booking.addendum.rebookingInvoice === true ? ' ' + rebookingumbuchung[getCurrentLocale] : '' }};&nbsp;</span>

                                                        <b>{{ passengers[getCurrentLocale] }}:</b> {{ get_ListOfPassengers(booking) }}
                                                    </small>
                                                </span>
                                            </h5>
                                            <dl class="info">
                                                <dt>{{ invoiceid[getCurrentLocale] }}</dt>
                                                <dd>{{ booking.addendum.idInvoice ? booking.addendum.idInvoice : '-' }} </dd>
                                                <dt>{{ bookingno[getCurrentLocale] }}</dt>
                                                <dd>{{ booking.addendum.bookingNo }}</dd>
                                                <dd style="margin-top: 5px; font-weight: 700;">{{ get_RouteOfBooking(booking) }}</dd>
                                            </dl>
                                            <button class="btn-mini status" style="background: #3bdd4e; width: 110px;" title=".pdf Download" v-on:click="onClick_PdfDownload(booking)">{{ downloadpdf[getCurrentLocale] }} &#10507;</button>
                                            <button class="btn-mini status" style="background: rgb(0, 160, 19);  width: 110px; margin-top: 5px;" title=".pdf Download" v-on:click="onClick_InvoiceDownload(booking)">{{ downloadinvoice[getCurrentLocale] }} &#10507;</button>
                                        </div>
                                    </div>
                                </div>
                            <!-- >>> Core -->
                            </div>
                            <!-- <<< Core -->


                            <!-- >>> Lower Buttons -->
                            <button type="button" class="btn-large full-width totalbutton" style="cursor: initial; outline: none !important; outline-style: none !important; margin-bottom: 15px; background: #00a013; font-size: 1.4em; height: 35px;" v-if="get_shared_AgencyGetBookings.length > 0">
                                <a href="#" v-on:click.prevent="onClick_ExcelDownload(booking)">
                                    <div class="xskin-color" style="font-size: 1.0625em; width: 100%;" >{{ downloadexcel[getCurrentLocale] }} &#10507;</div>
                                </a>
                            </button>
                            <button type="button" class="btn-large full-width totalbutton" style="cursor: initial; outline: none !important; outline-style: none !important; margin-bottom: 15px; background: #3bdd4e; font-size: 1.4em; height: 65px;" v-if="get_shared_AgencyGetBookings.length > 0">
                                {{ totalagencyprice[getCurrentLocale] }}: {{ Number(get_shared_AgencyAgencyTotalBrutto) | rndAmntRUAFWZ }},  {{ totalcustomerprice[getCurrentLocale] }}: {{ Number(get_shared_AgencyTotalBrutto) | rndAmntRUAFWZ }}
                                <br />
                                <span style="font-size: 0.5em;">{{ tincludedtaxes[getCurrentLocale] }}</span>
                            </button>
                            <!-- <<< Lower Buttons -->
                            <!-- <<< Some Booking Results ------------------ -->
                        </div>
                        <!-- <<< Left Side: Content -->




                        <!-- >>> Right Side: Sidebar -->
                        <div class="sidebar col-sms-6 col-sm-4 col-md-3 topDistance">
                            <h4 class="search-results-title">
                                <i class="soap-icon-search"></i><b>{{ get_shared_AgencyGetBookings.length }}</b> {{ resultsshown[getCurrentLocale] }}.
                            </h4>

                            <!-- >>> VueCmp - 'sdr-modifysearch-box', 'Modify Search' -->
                            <sdr-modifysearch-box></sdr-modifysearch-box>
                            <!-- <<< VueCmp - 'sdr-modifysearch-box', 'Modify Search' -->

                            <br />
                            <sdr-contact-box></sdr-contact-box>
                        </div>
                        <!-- <<< Right Side: Sidebar -->
                    </div>
                </div>
            </section>
            <!-- End:PageContent -->


            <!-- Begin:PromoBox -->
            <sdr-promobox></sdr-promobox>
            <!-- End:PromoBox -->
        </div>


        <div v-if="getFlagSharedAgencyLoggedIn === false">
            <!-- Begin:PageContent -->
            <section id="content">
                <div class="container">
                    <div class="row">
                        <!-- Begin:PagePrivacy -->
                        <div id="main" class="col-md-9">
                            <div class="container shortcode travel-ideas">
                                <h1 class="idea-title" style="color: red;"><span class="index"><i class="soap-icon-star circle"></i></span>{{ titleinfo_loggedout[getCurrentLocale] }}</h1>
                            </div>
                        </div>
                        <!-- End:PagePrivacy -->

                        <!-- Begin:Content-SideBar -->
                        <div class="sidebar col-md-3">
                            <sdr-contact-box></sdr-contact-box>
                        </div>
                        <!-- END:Content-SideBar -->
                    </div>
                </div>
            </section>
            <!-- End:PageContent -->


            <!-- Begin:PromoBox -->
            <sdr-promobox></sdr-promobox>
            <!-- End:PromoBox -->
        </div>
    </div>
</template>

<script>
    import ContactBox from '../shared/sidebar/ContactBox.vue'; // Sidebar (right)
    import ModifySearchBox from './pagecontent/ModifySearchBox.vue';

    import { mapActions } from 'vuex';
    import { mapGetters } from 'vuex';

    import moment from 'moment';


    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-modifysearch-box': ModifySearchBox,
            'sdr-contact-box': ContactBox,

        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                titleinfo: {
                    en: 'Your Agency - Bookings:',
                    de: 'Ihre Agentur - Buchungen:',
                },
                titleinfo_loggedout: {
                    en: 'You must be logged in with your agency!',
                    de: 'Sie müssen mit Ihrer Agentur eingeloggt sein!',
                },
                stillempty : {
                    en: 'Still empty? No Bookings? Perform a Search?',
                    de: 'Keine Buchungen zu sehen? Drücken Sie "Buchungen finden"?',
                },

                // >>> -------------------------- Search / Filter
                when: {
                    en: 'When',
                    de: 'Wann',
                },
                what: {
                    en: 'What',
                    de: 'Was',
                },
                filterbookings: {
                    en: 'FILTER BOOKINGS',
                    de: 'BUCHUNGEN FILTERN',
                },

                flightdatefilter: {
                    en: 'Flight date:',
                    de: 'Flugdatum:',
                },
                bookingcodefilter: {
                    en: 'Bookingno:',
                    de: 'Buchungscode:',
                },
                invoiceidfilter: {
                    en: 'Invoice Id:',
                    de: 'Rg.-Nummer:',
                },
                surnamefilter: {
                    en: 'Surname:',
                    de: 'Nachname:',
                },
                freecashlimit: {
                    en: 'Free Cash Limit',
                    de: 'Freies Barzahlungs Limit'
                },

                searchfor_flightdate: '',
                searchfor_bookingcode: '',
                searchfor_invoiceid: '',
                searchfor_surname: '',

                options: {
                    en: {
                        format: 'DD.MM.YYYY',
                        i18n: {
                            previousMonth : 'Previous Month',
                            nextMonth     : 'Next Month',
                            months        : ['January','February','March','April','May','June','July','August','September','October','November','December'],
                            weekdays      : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
                            weekdaysShort : ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
                        }
                    },
                    de: {
                        format: 'DD.MM.YYYY',
                        i18n: {
                            previousMonth : 'Vorheriger Monat',
                            nextMonth     : 'Nächster Monat',
                            months        : ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'],
                            weekdays      : ['Sonntag',' Montag',' Dienstag',' Mittwoch',' Donnerstag',' Freitag',' Samstag'],
                            weekdaysShort : ['SO','MO','DI','MI','DO','FR','SA']
                        }
                    },
                    // format: 'DD.MM.YYYY',
                    // minDate: moment().toDate(),
                    // maxDate: moment().add(7, 'days').toDate()
                },
                start: moment(),
                // <<< -------------------------- Search / Filter
                fullybooked: {
                    en: 'Booked',
                    de: 'Gebucht',
                },
                partialcancelled: {
                    en: 'Partial',
                    de: 'Teilstorno',
                },
                fullycancelled: {
                    en: 'Full cancel',
                    de: 'Vollstorno',
                },
                downloadpdf: {
                    en: 'E-Ticket',
                    de: 'E-Ticket',
                },
                downloadexcel: {
                    en: 'Export bookings',
                    de: 'Buchungen exportieren',
                },
                downloadinvoice: {
                    en: 'Invoice',
                    de: 'Rechnung',
                },
                rebookingumbuchung: {
                    en: '(R)',
                    de: '(U)',
                },
                // <<< --------------------------


                tincludedtaxes: {
                    en: 'incl. Taxes, Fees & Surcharges',
                    de: 'inkl. Steuern, Gebühren & Zuschlägen',
                },

                agenturprice: {
                    en: 'Agcy.Price',
                    de: 'Agt.-Preis',
                },
                agenturcommission: {
                    en: 'Comm.',
                    de: 'Komm.',
                },
                customerprice: {
                    en: 'Cust.Price',
                    de: 'Knd.-Preis',
                },

                passengers: {
                    en: 'Passagiere',
                    de: 'Passagiere',
                },
                invoiceid: {
                    en: 'Inv. No.',
                    de: 'Rg.-Nummer',
                },
                bookingno: {
                    en: 'Bookingno',
                    de: 'Buchungscode',
                },


                totalagencyprice: {
                    en: 'Total agency price',
                    de: 'Total Agenturpreis',
                },
                totalcustomerprice: {
                    en: 'Total costumer price',
                    de: 'Total Kundenpreis',
                },


                // >>> ------------------------------------
                resultsshown: {
                    en: 'booking(s) found',
                    de: 'Buchung(en)'
                },

                // getCurrentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'getFlagSharedAgencyLoggedIn', // is Agency logged in?
                'get_shared_AgencyTotalBrutto',
                'get_shared_AgencyAgencyTotalBrutto',
                'get_shared_AgencyAgencyCashLimit',
                'getSharedAgencyLoginResultsAgencyObject',
                'get_shared_AgencyBookingsParams',
                'get_shared_AgencyGetBookings',
                'get_shared_AgencyGetBookings_Filtered',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/



        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note:
        *
        */
        mounted: function() {

            // this.searchfor_flightdate = moment().toString(); // search/filter Flight date

        }, // eof mounted()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'act_set_filterSearchAgencyBookingsParams',
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSubmit_FilterSearch()
            *
            * Desc: Filter/Search Box submit.
            * Note:
            *
            */
            onSubmit_FilterSearch: function(submitEvent) {

                var me = this,
                    searchfilterObject = {},
                    searchfor_flightdate = '',
                    searchfor_bookingcode = '',
                    searchfor_invoiceid = '',
                    searchfor_surname = '';


                me.$toc('>>> /components/agency/Home.vue >>> onSubmit_FilterSearch');
                if (submitEvent.target.elements.searchfor_flightdate.value != '') {
                    searchfor_flightdate = submitEvent.target.elements.searchfor_flightdate.value.split('.');
                    searchfor_flightdate = String(moment(searchfor_flightdate[2] + '-' + searchfor_flightdate[1] + '-' + searchfor_flightdate[0]).format('YYYY-MM-DDT00:00:01'));
                }
                searchfor_bookingcode = this.searchfor_bookingcode;
                searchfor_invoiceid = this.searchfor_invoiceid;
                searchfor_surname = this.searchfor_surname;

                searchfilterObject = {
                    "searchfor_flightdate": searchfor_flightdate,
                    "searchfor_bookingcode": searchfor_bookingcode,
                    "searchfor_invoiceid": searchfor_invoiceid,
                    "searchfor_surname": searchfor_surname
                };

                this.act_set_filterSearchAgencyBookingsParams(searchfilterObject);

            }, // eof onSubmit_FilterSearch()




            /******************************************************************* 'Utilities/Getters'
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * get_ListOfPassengers()
            *
            * Desc:
            * Note:
            *
            */
            get_ListOfPassengers: function(booking) {

                let me = this,
                    i = 0,
                    paxList = '';


                me.$toc('>>> /components/agency/Home.vue >>> get_ListOfPassengers');
                if (booking.passengers.length > 0) {
                    for (i = 0; i < booking.passengers.length; i++) {
                        paxList = paxList + booking.passengers[i].firstName[0].trim() + '. ' +  booking.passengers[i].lastName.trim() + '; ';
                    }
                }


                return paxList.substring(0, paxList.length - 2);

            }, // eo function get_ListOfPassengers()


            /*******************************************************************
            * get_BookedOrPartialOrFull()
            *
            * Desc:
            * Note: 'fullybooked'       => green (#3bdd4e)
            * Note: 'partialcancelled'  => yellow (#ffd60a)
            * Note: 'fullycancelled'    => red (##E74C3C)
            *
            */
            get_BookedOrPartialOrFull: function(booking) {

                let me = this,
                    i = 0,
                    returnValue = '';


                me.$toc('>>> /components/agency/Home.vue >>> get_BookedOrPartialOrFull');
                // >>> 1. Check --------------------------- 'fullycancelled'
                if (booking.addendum.fullCancelled === true) {
                    returnValue = 'fullycancelled';
                }

                // >>> 2. Check --------------------------- 'partialcancelled'
                if (returnValue === '') {
                    if (booking.tickets.length > 0) {
                        for (i = 0; i < booking.tickets.length; i++) {
                            if (booking.tickets[i].cancelled === true) {
                                returnValue = 'partialcancelled';
                            }
                        }
                    }
                }

                // >>> 3. Check --------------------------- 'fullybooked'
                if (returnValue === '') {
                    returnValue = 'fullybooked';
                }


                return returnValue;

            }, // eo function get_BookedOrPartialOrFull()


            /*******************************************************************
            * get_RouteOfBooking()
            *
            * Desc:
            * Note:
            *
            */
            get_RouteOfBooking: function(booking) {

                let me = this,
                    route = '';


                me.$toc('>>> /components/agency/Home.vue >>> get_RouteOfBooking');
                // >>> Roundtrip --------------------------
                if (booking.outwardFlights.length > 0 && booking.inboundFlights.length > 0) {
                    route = booking.outwardFlights[0].departureAirport.iataCode + '-' + booking.outwardFlights[0].destinationAirport.iataCode +  '-' + booking.inboundFlights[0].destinationAirport.iataCode;
                }

                // >>> Oneway -----------------------------
                if (booking.outwardFlights.length === 0 || booking.inboundFlights.length === 0) {
                    // Outward only -----------------------
                    if (booking.outwardFlights.length > 0 ) {
                        route = booking.outwardFlights[0].departureAirport.iataCode + '-' + booking.outwardFlights[0].destinationAirport.iataCode;
                    }
                    // Return only -----------------------
                    if (booking.inboundFlights.length > 0 ) {
                        route = booking.inboundFlights[0].departureAirport.iataCode + '-' + booking.inboundFlights[0].destinationAirport.iataCode;

                    }
                }


                return route;

            }, // eo function get_RouteOfBooking()







            /*******************************************************************
            * onChange_FlightsSearchForm()
            *
            * Desc:
            * Note: Kind of Reset here.
            *
            */
            onChange_FlightsSearchForm: function() {

                var me = this;


                me.$toc('>>> /components/agency/Home.vue >>> get_RouteOfBooking');


            }, // eo function onChange_FlightsSearchForm()







            /******************************************************************* 'Utilities'
            * Utilities/Download:
            *******************************************************************/
            /*******************************************************************
            * onClick_PdfDownload()
            *
            * Desc:
            * Note:
            *
            */
            onClick_PdfDownload: function(booking) {

                let me = this,
                    url = '',
                    xhr = null,
                    idInvoice = booking.addendum.idInvoice;


                me.$toc('>>> /components/agency/Home.vue >>> onClick_PdfDownload');
                url = '/rest/booking/eticket/' + idInvoice;
                xhr = new XMLHttpRequest();
                xhr.open("GET", url);
                xhr.setRequestHeader("apiKey", '037ae1f2ba244a2a93b24121743bfdd6');
                // xhr.setRequestHeader("Authorization", A41CM.app.authKeyUser);
                xhr.responseType = "arraybuffer";

                xhr.onload = function () {
                    if (this.status === 200) {
                        /* works
                        var blob = new Blob([xhr.response], { type: "application/pdf" });
                        var objectUrl = URL.createObjectURL(blob);
                        window.open(objectUrl);
                        */

                        var a = document.createElement("a");
                        var url = window.URL.createObjectURL(new Blob([xhr.response], { type: "application/pdf" }));
                        var name = 'Invoice_' + idInvoice + '.pdf';

                        a.setAttribute("href", url);
                        a.setAttribute("download", name);
                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(url);
                        a.remove();
                    }
                };
                xhr.send();

            }, // eo function onClick_PdfDownload()


            /*******************************************************************
            * onClick_ExcelDownload()
            *
            * Desc:
            * Note:
            *
            */
            onClick_ExcelDownload: function() {

                let me = this,
                    url = '',
                    xhr = null,
                    params = {},
                    agencyObjectSearchParams = this.get_shared_AgencyBookingsParams,
                    agencyObjectFromLS = JSON.parse(this.getSharedAgencyLoginResultsAgencyObject);


                me.$toc('>>> /components/agency/Home.vue >>> onClick_ExcelDownload');
                url = '/rest/booking/getagencybookings/download';
                params = {
                    "idAgency": agencyObjectFromLS.idCustomer,
                    "fromDate": agencyObjectSearchParams.fromDate,
                    "toDate": agencyObjectSearchParams.toDate
                };
                xhr = new XMLHttpRequest();
                xhr.open("PUT", url);
                xhr.setRequestHeader("apiKey", '037ae1f2ba244a2a93b24121743bfdd6');
                // xhr.setRequestHeader("Authorization", A41CM.app.authKeyUser);
                xhr.responseType = "arraybuffer";

                xhr.onload = function () {
                    if (this.status === 200) {
                        // var blob = new Blob([xhr.response], { type: "application/csv" });
                        // var objectUrl = URL.createObjectURL(blob);
                        // window.open(objectUrl);

                        var myHeader = xhr.getResponseHeader('Content-Disposition');
                        var s  = String(myHeader.match(/(?:filename=")(.*?)(?=")/));
                        s = s.substr(10, s.length);
                        s = s.split(',');

                        var a = document.createElement("a");
                        var url = window.URL.createObjectURL(new Blob([xhr.response], { type: "application/csv" }));
                        var name = s[0];

                        a.setAttribute("href", url);
                        a.setAttribute("download", name);
                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(url);
                        a.remove();
                    }
                };
                xhr.send(JSON.stringify(params));

            }, // eo function onClick_ExcelDownload()


            /*******************************************************************
            * onClick_InvoiceDownload()
            *
            * Desc:
            * Note:
            *
            */
            onClick_InvoiceDownload: function(booking) {

                let me = this,
                    url = '',
                    xhr = null,
                    idInvoice = booking.addendum.idInvoice;


                me.$toc('>>> /components/agency/Home.vue >>> onClick_InvoiceDownload');
                url = '/rest/booking/invoice/' + idInvoice;
                xhr = new XMLHttpRequest();
                xhr.open("GET", url);
                xhr.setRequestHeader("apiKey", '037ae1f2ba244a2a93b24121743bfdd6');
                // xhr.setRequestHeader("Authorization", A41CM.app.authKeyUser);
                xhr.responseType = "arraybuffer";

                xhr.onload = function () {
                    if (this.status === 200) {
                        /* works
                        var blob = new Blob([xhr.response], { type: "application/pdf" });
                        var objectUrl = URL.createObjectURL(blob);
                        window.open(objectUrl);
                        */

                        var a = document.createElement("a");
                        var url = window.URL.createObjectURL(new Blob([xhr.response], { type: "application/pdf" }));
                        var name = 'Invoice2_' + idInvoice + '.pdf';

                        a.setAttribute("href", url);
                        a.setAttribute("download", name);
                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(url);
                        a.remove();
                    }
                };
                xhr.send();

            }, // eo function onClick_InvoiceDownload()

        }, // eof methods()
        /* <<< ****************************************************************/

    };
</script>

<style scoped>

    .tab-wrapper {
        background: #F5F5F5;
    }
    .tab-container .tab-content {
        background: #F5F5F5;
    }
    .tab-container.trans-style ul.tabs li a {
        background: #F5F5F5;
    }

    .tab-container.trans-style ul.tabs li.active a {
        color: #9F4378;
    }




    ul.arrow, ul.triangle, ul.circle, ul.check, ul.chevron, ul.arrow-square, ul.check-square, ul.check-circle, ul.decimal, ul.upper-roman, ul.lower-latin, ul.upper-latin {
        font-size: 1.0833em;
    }


    .topDistance {
        margin-top: 70px;
    }

    .totalbutton {
        padding-right: 7px;
        height: 43px;
        font-size: 1.6667em; /* 1.4167em, 1.1667em; 1.6667em */
        line-height: 15px;
        text-align: right;
        height: 57px;
    }


    .box-title small {
        font-size: 12px;
        text-transform: none;
    }


    button.btn-mini, input[type="button"].button.btn-mini, a.button.btn-mini {
        font-size: 1.1em;
    }


    #booking .booking-info .info {
        padding-left: 15px;
        width: 100px;
    }

    #booking .booking-info .status {
        margin-right: 5px;
    }

    /* >>>  iPAD -------------------------------------------------------------*/
    @media only screen
    and (min-device-width : 768px)
    and (max-device-width : 1024px)  {
        .toggle-container .panel.style1 .panel-content {
            padding: 10px 15px 15px 10px;
        }
    }
</style>

<style>

</style>